import React from 'react';
import { Row, Col, Container, Image } from 'react-bootstrap';
import styles from './index.module.css';
import FormBox from '../FormBox';
import MegaPhone from '../../images/info_megaphone.svg';

const Info = () => (
  <Container fluid="xl" className={`${styles.info_container}`}>
    <Row className={`${styles.info_all}`}>
      <Col className={`${styles.info_wrapper}`}>
        <p>
          This Autism Action Month, empower yourself with information,
          strategies, and resources to help maximize the potential of children
          diagnosed with autism and <span>improve their quality of life.</span>
        </p>
        <Image className={`${styles.mega_phone}`} src={MegaPhone} />
      </Col>
      <Col>
        <FormBox />
      </Col>
    </Row>
  </Container>
);

export default Info;
